(function($) {
	
	if ( !$('#interactive-map').length )
		return;

	$('#interactive-map .map-controls li').on('click', function(event) {
		event.preventDefault();
		var layer_id = $(this).data('layer');
		var $layer = $('#'+layer_id);
		var $self = $(this);

		if ( $self.hasClass('on') ) {
			$layer.fadeOut('500');
			$self.removeClass('on');
			
		} else {
			$layer.fadeIn('500');
			$self.addClass('on');
		}
	});

	$('#interactive-map .map-controls li').get(0).click();

	if( /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent) ) {
		var el = document.querySelector('#zoomable-map');
		new PinchZoom.default(el, {});
		$('.pinchzoom').removeClass('d-none');
	}

})(jQuery);